import type { Preferences } from "@smartsuite/types/lib/models/preferences";
import type { Fields } from "@smartsuite/smartsuite-client";
import type { ActivityRecord } from "../../stores/jobs.store";

import { DateField } from "./ActivityGrid/components/DateField/DateField";
import { DurationField } from "./ActivityGrid/components/DurationField/DurationField";
import { StatusField } from "./ActivityGrid/components/StatusField/StatusField";
import { TextField } from "./ActivityGrid/components/TextField/TextField";

interface ComponentProps {
  // TODO: Make generic type
  value: any;
  record: ActivityRecord;
  userPreferences?: Preferences;
}

export const automationsActivityRenders: Record<
  Fields,
  { component: React.FunctionComponent<ComponentProps>; isCentered: boolean }
> = {
  datefield: {
    // @ts-expect-error
    component: DateField,
    isCentered: false,
  },
  statusfield: {
    component: StatusField,
    isCentered: true,
  },
  durationfield: {
    component: DurationField,
    isCentered: true,
  },
  textfield: {
    component: TextField,
    isCentered: true,
  },
};
